import React from 'react';

const LazyImage = ({ image, childCss, title, ...rest }) => {
    if (!image) return null;

    return <img
        className={`${childCss} lazyload`}
        key={image}
        alt=""
        data-srcset={image}
        data-sizes="auto"
        title={title}
        {...rest}
    />;
};

LazyImage.defaultProps = {
    childCss: '',
    title: ''
};

export default LazyImage;
